<template>
  <div class="orghome">
    <div class="layer">
      <div class="commonhbox width">
        <div class="search-t">
          <label for style="margin-left:30px;">检索内容</label>
          <el-input
            style="display:inline-block;width: 200px;margin-left:15px;"
            placeholder="请输入机构名称"
            v-model.trim="organization"
            @keyup.enter.native="searchOrg()"
            clearable
          ></el-input>
          <el-button
            style="margin-left:30px;background: #75867c;"
            type="primary"
            icon="el-icon-search"
            :loading="loading1"
            @click="searchOrg()"
          >搜索</el-button>
        </div>
      </div>
      <div class="container width">
        <H2 v-if="Object.keys(org).length">检索结果</H2>
        <div
          class="org-list"
          v-loading="loading1"
          style="min-height: 0px"
          v-if="Object.keys(org).length"
        >
          <div class="org-box">
            <div class="org-left">
              <div>
                <h3>{{org.name}}</h3>
                <p>{{org.nameAlt}}</p>
              </div>
              <div>专家：{{expcount}}位 | 成果：{{rescount}}个</div>
            </div>
            <div class="org-right" >
              <img :src="org.logo" alt v-if="org.logo" class="img"/>
               <div v-else class="img"></div>
               <router-link class="detailbtn" :to="{name:'Overview',query:{organization:org.name}}">查看详情</router-link>
            </div>
          </div>
        </div>
        <div v-if="IsNull" class="null">当前查询机构无有效数据</div>
        <H2 for>热门机构</H2>
        <div class="org-list" v-loading="loading">
          <div class="org-box" v-for="(item,index) in orglist" :key="index">
            <div class="org-left">
              <div>
                <h3>{{item.data.result[0].name}}</h3>
                <p>{{item.data.result[0].nameAlt}}</p>
              </div>
              <div>专家：{{item.stat.topCreators}}位 | 成果：{{item.results}}个</div>
            </div>
            <div class="org-right">
              <img :src="item.data.result[0].logo" alt  v-if="item.data.result[0].logo" class="img"/>
               <div v-else class="img"></div>
              <router-link
                class="detailbtn"
                :to="{name:'Overview',query: {organization: item.data.result[0].name}}"
              >查看详情</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrg, getRandOrg } from '@/api/organization'
export default {
  name: 'Home',
  data () {
    return {

      organization: '', // 机构
      orglist: [], // 热门机构列表
      org: [], // 机构信息
      expcount: '', // 专家个数
      rescount: '', // 成果个数
      loading: false, // 加载动画
      loading1: false, // 加载动画2
      IsNull: false // 是否有数据
    }
  },
  methods: {
    // 查询机构
    searchOrg () {
      this.loading1 = true
      const data = {
        name: this.organization
      }
      getOrg(data)
        .then(res => {
          this.loading1 = false
          if (!Object.keys(res.data.data.result[0]).length) {
            this.IsNull = true
            return
          }
          this.IsNull = false
          this.org = res.data.data.result[0]
          this.expcount = res.data.stat.topCreators
          let rescount = 0
          res.data.stat.topResources.forEach(item => {
            rescount += item.doc_count
          })
          this.rescount = rescount
        })
        .catch(err => {
          this.IsNull = true
          this.org = []
          this.loading = false
          console.log(err)
        })
    }
  },
  mounted () {
    this.loading = true
    // 获取热门机构
    getRandOrg()
      .then(res => {
        this.loading = false
        res.data.forEach((item, index) => {
          let sum = 0
          item.stat.topResources.forEach((temp, val) => {
            sum += temp.doc_count
          })
          res.data[index]['results'] = sum
        })
        this.orglist = res.data
      })
      .catch(err => {
        console.log(err)
      })
    if (this.$route.query.organization !== undefined) {
      this.organization = this.$route.query.organization
      this.searchOrg()
    }
  }
}
</script>

<style lang="scss">
.orghome {
  background-color: #f5f5f5;
  padding-top: 30px;
  .commonhbox {
    padding: 30px;
    background: white;
  }
  .container {
    margin-top: 30px;
    padding: 30px;
    background: white;
    .null {
      margin: 30px 0;
      font-weight: 600;
      font-size: 20px;
    }
    .org-type {
      margin-bottom: 30px;
      label {
        float: left;
        margin: 10px 15px 0 0;
      }
      ul {
        float: left;
        border: 1px #ccc solid;
        li {
          float: left;
          width: 80px;
          height: 36px;
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          cursor: pointer;
          border-right: 1px #ccc solid;
          &:last-child {
            border-right: none;
          }
          &:hover {
            background-color: #409eff;
            color: #fff;
          }
        }
      }
    }
    .org-list {
      min-height: 500px;
      padding-top: 30px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .org-box {
        padding: 15px;
        width: 32%;
        border: 1px solid #ccc;
        margin-bottom: 15px;
        height: 250px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-left: 1%;

        .org-left {
          width: 80%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-bottom: 20px;
          h3 {
            font-size: 30px;
            margin-bottom: 10px;
          }
          p {
            font-size: 16px;
          }
          div {
            font-size: 14px;
          }
        }
        .org-right {
          text-align: center;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          padding-bottom: 10px;
          .img {
            width: 80px;
            height: 80px;
          }
          .detailbtn {
            float: right;
            box-sizing: border-box;
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #fff;
            background: #75867c;
            border-color: #b3d8ff;
            border: 1px solid #dcdfe6;
            font-size: 14px;
            border-radius: 4px;
            &:hover {
              background: #3a8ee6;
              border-color: #3a8ee6;
              color: #fff;
              outline: 0;
              transition: 0.5s;
            }
          }
        }
      }
      // .row-list {
      //   position: relative;
      //   margin-bottom: 30px;
      //   h2 {
      //     position: absolute;
      //     left: -40px;
      //   }
      //   ul {
      //     width: 100%;
      //     li {
      //       float: left;
      //       width: 32%;
      //       margin-right: 2%;
      //       margin-bottom: 15px;
      //       border: 1px #ccc solid;
      //       padding: 15px;
      //       &:nth-child(3n) {
      //         margin-right: 0;
      //       }
      //       .list-t {
      //         margin-bottom: 15px;
      //         .list-t-l {
      //           float: left;
      //           width: 200px;
      //           height: 60px;
      //           h3 {
      //             font-size: 30px;
      //           }
      //           p {
      //             font-size: 16px;
      //           }
      //         }
      //         .list-t-r {
      //           float: right;
      //           margin-left: 15px;
      //           img {
      //             display: block;
      //             width: 80px;
      //             height: 80px;
      //           }
      //         }
      //       }
      //       .list-b {
      //         p {
      //           float: left;
      //           font-size: 14px;
      //           margin-top: 10px;
      //         }
      //         .detailbtn {
      //           float: right;
      //           box-sizing: border-box;
      //           width: 100px;
      //           height: 40px;
      //           line-height: 40px;
      //           text-align: center;
      //           color: #409eff;
      //           background: #ecf5ff;
      //           border-color: #b3d8ff;
      //           border: 1px solid #dcdfe6;
      //           font-size: 14px;
      //           border-radius: 4px;
      //           &:hover {
      //             background: #3a8ee6;
      //             border-color: #3a8ee6;
      //             color: #fff;
      //             outline: 0;
      //             transition: 0.5s;
      //           }
      //         }
      //       }
      //     }
      //   }
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/organization/OrgHome.vue